import { safeInteropRegister, toGoLang } from "../../api-polyfill/src/common/windowFunctions";
export class DistributedStoreService {
    constructor(glue, logger) {
        this.glue = glue;
        this.logger = logger;
        this.storesInitialized = {};
    }
    async start() {
        this.glue.interop.register("FSBL.Clients.DistributedStoreClient.init", safeInteropRegister(async (params) => {
            const { store, value } = params;
            if (this.storesInitialized[store]) {
                return;
            }
            this.storesInitialized[store] = true;
            const { err } = await toGoLang(() => this.glue.contexts.update(store, value));
            if (err) {
                this.logger.error("distribute-store-service - failed to update context", store, err);
            }
        }, this.logger));
    }
}
